import { useAtom } from 'jotai';
import { userAtom } from '@/global-store.ts';
import { useTranslation } from 'react-i18next';
import OfferContactForm from '@components/OfferContactForm.jsx';
import FeatureOfferBanner from '@components/FeatureOfferBanner.jsx';
import { XIcon } from 'lucide-react';

export function ReportLicenseExpiredBanner() {
  const { t } = useTranslation();

  const [user] = useAtom(userAtom);

  return (
    <>
      <div className='eye:p-s eye:bg-red-25 eye:rounded-md eye:flex eye:gap-2xs'>
        <div>
          <XIcon className='eye:text-red-100' />
        </div>
        <div className='eye:flex eye:max-md:flex-col eye:items-center eye:gap-2xs eye:-mt-5xs'>
          <div className='eye:font-semibold eye:text-black'>
            {t('reportLicenseExpired')}
          </div>
          <OfferContactForm product={'Eye-Able Report'} />
        </div>
      </div>

      {user.role === 'customer' && (
        <FeatureOfferBanner product='Eye-Able Report' />
      )}
    </>
  );
}
